import type * as React from 'react'

// Shared "trackingmcp" UI primitives — a headline stat card, a pill filter, and an uppercase
// micro-label field. Keeps /weather, /ports and /disruptions on one consistent card language.

/** Headline stat card: uppercase tracked micro-label + a big display number. */
export function Stat({
  label,
  value,
  unit,
  accent = false,
}: {
  label: string
  value: number | string
  unit?: string
  accent?: boolean
}) {
  return (
    <div
      className={`rounded-xl border px-5 py-4 ${accent ? 'border-signal' : 'border-border-strong'}`}
      style={accent ? { background: 'rgb(var(--signal-rgb) / 0.06)' } : undefined}
    >
      <div className="text-[11px] font-medium uppercase tracking-[0.08em] text-[var(--text-muted)] mb-1.5">
        {label}
      </div>
      <div className="font-display font-bold text-[30px] leading-none text-[var(--text-primary)]">
        {value}
        {unit && (
          <span className="text-base font-medium text-[var(--text-muted)] ml-1.5">{unit}</span>
        )}
      </div>
    </div>
  )
}

/** Rounded pill toggle for filter rows. */
export function Pill({
  on,
  onClick,
  children,
}: {
  on: boolean
  onClick: () => void
  children: React.ReactNode
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`rounded-full border px-3.5 py-1.5 text-sm transition-colors ${
        on
          ? 'border-signal text-signal font-semibold'
          : 'border-border-strong text-[var(--text-secondary)] hover:border-signal'
      }`}
    >
      {children}
    </button>
  )
}

/** Uppercase micro-label + mono value, for card detail grids. */
export function Field({ k, v }: { k: string; v: string }) {
  return (
    <div>
      <dt className="text-[10px] uppercase tracking-[0.07em] text-[var(--text-muted)]">{k}</dt>
      <dd className="font-mono text-sm text-[var(--text-primary)] mt-0.5">{v}</dd>
    </div>
  )
}
